<div class="content">
  <h3>{{ 'ADD_CREDIT.CHOOSE_AMOUNT' | translate }}</h3>

  @for (bonus of bonusAmounts; track $index) {
    <button class="bonus-amount" matButton="filled" color="primary" (click)="addBonus(bonus)">
      <span>
        {{ paymentConfig.bonusBaseAmount * bonus | euro: true }}
        @if (paymentConfig.bonusAmount) {
          <span> + {{ paymentConfig.bonusAmount * bonus | euro: true }} {{ 'ADD_CREDIT.GRATIS' | translate }}</span>
        }
      </span>
    </button>
  }

  <button class="other-amount" matButton="filled" color="primary" (click)="addOther()">
    <span>{{ 'ADD_CREDIT.OTHER_AMOUNT' | translate }}</span>
  </button>
  <h5>{{ 'ADD_CREDIT.MINIMUM_AMOUNT' | translate }}: {{ paymentConfig.minimumAmount | euro: true }}</h5>

  <button class="cancel-button" matButton="outlined" (click)="cancel()">
    <span>{{ 'COMMON.CANCEL' | translate }}</span>
  </button>
</div>
